import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd034aService,
  Sgkd034aRequest,
  Sgkd034aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd002dSgkd034aService {

  private _rsesult$ = new Subject<Sgkd034aResponse>();

  // get contractorValueChanges(): Observable<Sgkd034aResponse> {
  //   return this._rsesult$.asObservable();
  // }

  constructor(private sgkd034aService: Sgkd034aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 請求お客さま番号を基に住所情報・お客さま氏名取得API呼び出し
   * 
   * @param claimCtrNo 請求お客さま番号
   * @param date 日付
   * @memberof UsedSgkd002dSgkd034aService
   */
  doSgkd034a(claimCtrNo: string, date: string): Observable<Sgkd034aResponse> {
  //doSgkd034a(claimCtrNo: string, date: string): Observable<boolean> {  

    // リクエスト生成
    let request: Sgkd034aRequest = {
      requestDto: {
        /** 取得対象テーブル区分 */
        shutokutargetTablediv: SgKdConstants.CODE_SHTKTARGETTBLDIV_SEIKYUSAKI,
        /** 参照先テーブル区分 */
        referencedbyTablediv: SgKdConstants.CODE_REFBYTBLDIV_3,
        /** 請求お客さま番号 */
        recptFixNo: claimCtrNo,
        /** 基準日付 */
        stdday: date
      }
    };

    return this.sgkd034aService.doSGKD034APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
          //return true;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD034A');
          return throwError(err.message);
        }
      )
    );
  }

  /**
   * 供給地点特定番号を基に住所情報・お客さま氏名取得API呼び出し
   * 
   * @param suppntSpno 供給地点特定番号
   * @param date 日付
   * @memberof UsedSgkd002dSgkd034aService
   */
  doSgkd034aWithSuppntSpno(suppntSpno: string, date: string): Observable<Sgkd034aResponse> {

    // リクエスト生成
    let request: Sgkd034aRequest = {
      requestDto: {
        /** 取得対象テーブル区分 */
        shutokutargetTablediv: SgKdConstants.CODE_SHTKTARGETTBLDIV_KYOKYUSAKI,
        /** 参照先テーブル区分 */
        referencedbyTablediv: SgKdConstants.CODE_REFBYTBLDIV_2,
        /** 供給地点特定番号 */
        suppntSpno: suppntSpno,
        /** 基準日付 */
        stdday: date
      }
    };

    return this.sgkd034aService.doSGKD034APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
          //return true;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD034A');
          return throwError(err.message);
        }
      )
    );
  }
}
